import { render } from "./LiveTranscriptionRenderer.vue?vue&type=template&id=5a2eb427&scoped=true&ts=true"
import script from "./LiveTranscriptionRenderer.vue?vue&type=script&lang=ts"
export * from "./LiveTranscriptionRenderer.vue?vue&type=script&lang=ts"

import "./LiveTranscriptionRenderer.vue?vue&type=style&index=0&id=5a2eb427&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2eb427"]])

export default __exports__